/**
 * axios配置
 */
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import setting from './setting'


Vue.use(VueAxios, axios);

axios.defaults.baseURL = setting.baseURL;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json';


